module.exports = __webpack_public_path__ + "static/img/index_banner5.c5da781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_banner5.png
// module id = MFKt
// module chunks = 1